<template>
  <IQOS :hideTitle="true" class="iqos-long no-border-card" boxClass="container-box m-0 p-0">
    <div class="cafe-card-container">
      <div class="cafe-card-left">
        <div class="cafe-card-general">
          <div class="card-image">
            <img
              :src="cafe.image ? cafe.image : '/icons/cafe-placeholder.jpg'"
              class="cafe-image"
            />
          </div>
          <div class="general-info">
            <div>
              <h2 class="info-name">{{ cafe.name }}</h2>
              <div class="info-text-line" v-if="cafe.address">
                <img src="/icons/addres-pointer-icon.svg" alt="" /><span
                  class="address c-grey"
                  >{{ $t("general.cafe.address") }} {{ cafe.address }}</span
                >
              </div>
              <div class="info-text-line" v-if="scheduleText">
                <img src="/icons/clock-icon.svg" alt="" /><span
                  class="address c-grey"
                >
                  {{ scheduleText }}</span
                >
              </div>
            </div>
            <DashboardButton
              class="settings-btn"
              @click="switchToCafe(cafe._id)"
            >
              {{ $t("general.cafe.settings") }}
            </DashboardButton>
          </div>
          <div class="card-tags">
            <button class="card-mode-tag i" v-if="cafe.modes.inside"></button>
            <button class="card-mode-tag p" v-if="cafe.modes.preorder"></button>
            <button class="card-mode-tag d" v-if="cafe.modes.delivery"></button>
            <button class="card-mode-tag r" v-if="cafe.modes.reserve"></button>
            <!-- <button class="card-mode-tag m">MARKETPLACE</button> -->
          </div>
        </div>
      </div>
    </div>
  </IQOS>
</template>

<style scoped>
.cafe-card-container {
  display: flex;
  height: calc(26.666vh - 4.45vh);
  padding-left: 52.666vh;
}
.cafe-card-general {
  display: flex;
  height: 100%;
}

.info-name {
  line-height: 0.8;
  font-size: 2.8vh;
  margin-bottom: 1.666vh;
}
.info-text-line {
  display: flex;
  align-items: center;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #908f8d;
  margin-bottom: 1.1111vh;
}
.info-text-line img {
  width: 1.6666vh;
  margin-right: 1.1111vh;
}
span.address {
  font-size: 1.7vh;
  display: block;

  line-height: normal;
}

.card-image {
  margin-right: 1.7vh;
  height: 100%;
  width: 52.666vh;
  position: absolute;
  top: 0;
  left: 0;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blur {
  filter: blur(2px);
}

.settings-btn {
  position: absolute;
  bottom: 0;
  width: 61.222vh;
}

.card-tags {
  display: flex;
  flex-flow: column;
  bottom: 3.2vh;
  position: absolute;
  top: 2.2222vh;
  right: 0;
  z-index: 0;
  overflow: hidden;
}

.card-mode-tag:first-child {
  margin-top: 0;
}

.card-mode-tag {
  height: 1.1111vh;
  width: 3.3333vh;
  border-radius: 1.6666vh 0 0 1.6666vh;
  font-weight: bold;
  margin-bottom: 0.5555vh;
  border: none;
  outline: none;
  border: none;
  outline: none;
  color: #1d1d1d;
}

.card-mode-tag.i {
  background: #129b81;
}
.card-mode-tag.d {
  background: #cbd9e6;
}
.card-mode-tag.p {
  background: #ffd2a8;
}

.card-mode-tag.m {
  background: #aeccc6;
}

.card-mode-tag.r {
  background: #aeccc6;
}

button.add-cafe {
  width: 100%;
  background: transparent;
  height: 10vh;
  cursor: pointer;
  transition: 0.3s;
  border: 1px solid #ededed;
  color: #ededed;
  border-radius: 1.2vh;
  margin-top: 2.3vh;
  text-align: center;
  font-size: 2.3vh;
}

button.add-cafe:hover {
  background: #ededed;
  color: #1d1d1d;
}

.cafe-image,
.cafe-image-placeholder {
  object-fit: cover;
  border-radius: 1vh 0 0 1vh;
}

.general-info {
  width: 61.222vh;
  position: relative;
  margin-right: 1.7vh;
  color: #ededed;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mode-switcher {
  background: #ededed;
  border-radius: 0.3vh;
  display: flex;
  height: 3vh;
  align-self: center;
  user-select: none;
}

.switch {
  text-align: center;
  border-radius: 0.3vh;
  width: 50%;
  font-size: 1.8vh;
  padding: 0.2vh 1vh;
  cursor: pointer;
  align-self: center;
  color: #464646;
}

.switch-active {
  color: #ededed;
  background: #464646;
}

.lite.switch-active {
  color: #aeccc6;
  background: #464646;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;
  width: 100%;
}

.modal-button {
  background: transparent;
  font-size: 2vh;
  border: 1px solid #ededed;
  color: #ededed;
  text-align: center;
  padding: 0.5vh 1vh;
  border-radius: 0.8vh;
  cursor: pointer;
}

p.comment {
  margin: 0;
  padding-top: 2.3vh;
  font-size: 1.7vh;
}

.cancel {
  border: 1px solid #908f8d;
  color: #908f8d;
}

.no-border-card {
  border: 0 !important;
}
</style>

<script>
import IQOS from "@/components/IQOS.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import BlackInput from "@/components/BlackInput.vue";

import moment from "moment";

export default {
  data() {
    return {};
  },
  props: {
    cafe: Object,
  },
  methods: {
    switchToCafe(id) {
      this.$store
        .dispatch("switchCafe", id)
        .then(() => {
          this.$router.push("/cafe");
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {
    scheduleText() {
      if (!this.cafe.schedule) return null;
      let day = moment().weekday();

      //moment days are 0 indexed from sunday, but we start from monday
      if (day == 6) {
        day = 0;
      } else {
        day++;
      }

      const schedule_item = Object.values(this.cafe.schedule)[day];

      if (!this.schedule_item) return null;

      if (!schedule_item.workday) return null;

      const fmt = (n) => `${n}`.padStart(2, "0");

      return `${fmt(schedule_item.startHour)}:${fmt(
        schedule_item.startMinute
      )} - ${fmt(schedule_item.endHour)}:${fmt(schedule_item.endMinute)}`;
    },
  },
  components: {
    IQOS,
    DashboardButton,
    BlackInput,
  },
};
</script>
